module.exports = __webpack_public_path__ + "static/49import-dce6867e9ce5ed2b0ae973732995e05f.png";